<script setup>
/**
 * OCHAT: the sidebar header, in place of upstream's account switcher.
 *
 * Ochat instances are single-account, so the switcher only ever listed one entry.
 * This shows the wordmark instead, plus an explicit collapse toggle (upstream
 * only exposes collapsing through the drag handle and a keyboard shortcut).
 *
 * The name comes from globalConfig, not a literal: an earlier version hardcoded
 * "Ochat" here, which quietly ignored INSTALLATION_NAME.
 */
import { useMapGetter } from 'dashboard/composables/store';
import Logo from 'next/icon/Logo.vue';

defineProps({
  isCollapsed: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['toggle']);

const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <template v-if="isCollapsed">
    <Logo class="size-9" />
    <button
      class="flex justify-center items-center transition-colors size-9 ochat-shape text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12"
      :aria-label="$t('SIDEBAR.EXPAND')"
      @click="$emit('toggle')"
    >
      <span class="i-ph-caret-right-bold size-6" />
    </button>
  </template>
  <template v-else>
    <div class="flex flex-grow gap-2 items-center min-w-0">
      <Logo class="flex-shrink-0 size-9" />
      <span
        class="text-2xl font-semibold tracking-tight truncate text-n-slate-12"
      >
        {{ globalConfig.installationName }}
      </span>
    </div>
    <button
      class="flex flex-shrink-0 justify-center items-center transition-colors size-9 ochat-shape text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12"
      :aria-label="$t('SIDEBAR.COLLAPSE')"
      @click="$emit('toggle')"
    >
      <span class="i-ph-caret-left-bold size-6" />
    </button>
  </template>
</template>
